<template>
    <!--@formatter:off-->
    <div class="bx_btn_switch ">
        {{label}}
        <!-- [D] 텍스트 on/off 변경 -->
        <button class="btn_switch" :class="{is_active: value}" @click="toggle">{{stateText}}</button>
    </div>
    <!--@formatter:on-->
</template>

<script>
export default {
    name: "SwitchButton",

    props: {
        label: {
            type: String,
            required: true,
        },

        value: {
            type: Boolean,
            required: true,
        },
    },

    computed: {
        stateText() {
            return this.value ? 'ON' : 'OFF';
        },
    },

    methods: {
        toggle() {
            this.$emit('input', !this.value);
        },
    },
}
</script>

<style scoped>

</style>